import Image from 'next/image'
import React from 'react'
import { ChallengeCardProps } from '..'
import { BadgeHeader } from '../BadgeHeader'
import { BaseCard } from '../BaseCard'
import { CardFooter } from '../CardFooter'
import { DiscountHeader } from '../DiscountHeader'
import { Overlay } from '../Overlay'

// import { toBase64, shimmer } from 'src/common/utils'

export const ChallengeCard = ({
    title,
    excerciseType = null,
    badgeType = 'none',
    intensity = 1,
    duration = '25min',
    imageURL,
    progress,
    trainers = [],
    percentOff = 0,
    premiumText,
    href = '/'
}: ChallengeCardProps) => {
    return (
        <BaseCard cardType="narrow" href={href} boxShadow={false}>
            <Image
                alt={`${title} card image`}
                src={imageURL}
                width={225}
                height={300}
                // key={`challenge-${imageURL}`}
                unoptimized={false}
                objectFit="cover"
                className="bg-gray-400"
                // loader={({ src }) => {
                //     return `${src}`
                // }}
                // placeholder="blur"
                // blurDataURL={`data:image/svg+xml;base64,${toBase64(shimmer(225, 300))}`}
            />
            {/* <img
                loading="lazy"
                alt={`${title} card image`}
                src={imageURL}
                className="object-cover w-[225px] h-[300px]"
            /> */}
            <BadgeHeader badgeType={badgeType} premiumText={premiumText} />
            <DiscountHeader percent={percentOff} />
            <CardFooter
                type="challenge"
                title={title}
                subtitle={`${
                    excerciseType ? excerciseType + ' • ' : ''
                }${duration}`.toUpperCase()}
                intensity={intensity}
                trainers={trainers}
                progress={progress}
            />
            <Overlay />
        </BaseCard>
    )
}
